import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./authSlice";
import roleReducer from "./roleSlice";
import themeReducer from "./theme";
// import chatNotificationReducer from "./chatNotificationSlice";
// import notificationReducer from "./notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    role: roleReducer,
    theme: themeReducer,
    // chatNotification: chatNotificationReducer,
    // notification: notificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
